<div class="my-assigned-events-container">
  <h2 class="my-assigned-events-container__title">
    <i class="pi pi-users"></i>
    Eventos que você colabora
  </h2>
  <app-events-table
    [eventsPage]="myEvents$ | async"
    [showPagination]="true"
    [rows]="5"
    (pageChangeClick)="handlePageChange($event)" />
</div>
